var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionArrowOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "highlight",
    fill: "none",
    stroke: "#3A3537",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    d: "M11.362 30.755L31.51 10.608M32.195 9.922L13.392 9.922M32.195 9.922L32.195 28.726"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionArrowOut);
export default __webpack_public_path__ + "static/media/action-arrow-out.f3033da77d5948bc0886fcb63dbc0bad.svg";
export { ForwardRef as ReactComponent };